export const upgradeContainer = "u1umc015";
export const lock = "l52ch2q";
export const freeContainer = "f1l3l3ud";
export const partnerContainer = "p20c89k";
export const root = "r11q4quh";
export const ctaBlock = "c1d5qx3e";
export const desc = "dt1trm";
export const cta = "cjnkyag";
export const top = "ttccj66";
export const bottom = "b1y1vo20";
export const title = "t1k8g69a";

require("./style.linaria.module.css!=!../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");